import { Ref } from 'vue'

import { User } from '@/domain/entities/user/user'
import { DisplayLanguageType } from '@/domain/value_objects/language/displayLanguageType'
import { SubmissionStatusViewModel } from '@/presentation/viewmodels/dashboard/submissionStatusViewModel'
import { getBarChartOptions } from '@/util/dashboard/barChartOptions'

export class SubmissionStatusPresenter {
  private viewModel: SubmissionStatusViewModel

  constructor(viewModel: SubmissionStatusViewModel = new SubmissionStatusViewModel()) {
    this.viewModel = viewModel
  }

  get chartData(): Ref<{ labelData: string[]; chartData: number[][] }> {
    return this.viewModel.chartData
  }

  get chartSeries(): Ref<any[]> {
    return this.viewModel.chartSeries
  }

  get chartOptions(): Ref<any> {
    return this.viewModel.chartOptions
  }

  get hasData(): Ref<boolean> {
    return this.viewModel.hasData
  }

  initChart = (
    userList: User[],
    color: string,
    otherColor: string,
    displayLanguage: DisplayLanguageType,
    isLightMode: boolean
  ) => {
    const chartData = this.getChartOfDailyEffortData(userList)

    if (chartData.chartData.length == 0) {
      this.viewModel.setHasData(false)
      return
    }

    try {
      const chartSeries = []
      for (let i = 0; i < userList.length; i++) {
        chartSeries.push(this.getChartData(userList[i].id, chartData.chartData[i], i == 0 ? color : otherColor))
      }
      const chartOptions = getBarChartOptions(
        displayLanguage == 'Japanese' ? '提出ステータス' : 'Submission Status',
        color,
        chartData.labelData,
        isLightMode
      )
      this.viewModel.setChartData(chartData)
      this.viewModel.setChartSeries(chartSeries)
      this.viewModel.setChartOptions(chartOptions)
      this.viewModel.setHasData(true)
    } catch (e) {
      this.viewModel.setHasData(false)
    }
  }

  private getChartData = (name: string, values: any, color: string) => {
    return {
      name: name,
      data: values,
      color: color
    }
  }

  // チャート用のデータを取得
  getChartOfDailyEffortData = (userList: User[]) => {
    const chartData: number[][] = []

    const labelData: string[] = []
    labelData.push('Accepted')
    labelData.push('WrnogAnswer')
    labelData.push('TimeLimit')
    labelData.push('MemoryLimit')
    labelData.push('OutputLimit')
    labelData.push('CompileError')
    labelData.push('RuntimeError')

    for (let i = 0; i < userList.length; i++) {
      chartData[i] = []
      chartData[i].push(userList[i].status != null ? userList[i].status!.accepted : 0)
      chartData[i].push(userList[i].status != null ? userList[i].status!.wrongAnswer : 0)
      chartData[i].push(userList[i].status != null ? userList[i].status!.timeLimit : 0)
      chartData[i].push(userList[i].status != null ? userList[i].status!.memoryLimit : 0)
      chartData[i].push(userList[i].status != null ? userList[i].status!.outputLimit : 0)
      chartData[i].push(userList[i].status != null ? userList[i].status!.compileError : 0)
      chartData[i].push(userList[i].status != null ? userList[i].status!.runtimeError : 0)
    }

    return { labelData, chartData }
  }
}
